module.exports = __webpack_public_path__ + "img/about11.7acbdafc.jpg";